<template>
  <main>
    <template v-for="(section, key) in eSpots" :key>
      <lazy-cms-section v-if="section" :section />
    </template>
  </main>
</template>

<script lang="ts" setup>
const eSpots = (await useCms().getSections.generic('sza')).data.value?.content.sections

definePageMeta({ header: { transparent: true } })
</script>
